<template>
  <div class="d-flex flex-column ga-4">
    <select-resource
      v-if="!disabled.localeId"
      v-model="params.localeId"
      :error-messages="errors.get('params.localeId')"
      item-name="englishName"
      :label="$t('jobs.types.LocaleCopy.localeId')"
      name="localeId"
      resource="locales"
    />
    <select-resource
      v-model="params.sourceLocaleId"
      :disabled="disabled.sourceLocaleId"
      :error-messages="errors.get('params.sourceLocaleId')"
      item-name="englishName"
      :label="$t('jobs.types.LocaleCopy.sourceLocaleId')"
      name="sourceLocaleId"
      resource="locales"
    />
    <v-select
      v-model="params.subTasks"
      :error-messages="errors.get('params.subTasks')"
      hide-details="auto"
      :items="subTasks"
      :label="$t('jobs.types.LocaleCopy.subTasks._')"
      multiple
      name="subTasks"
      prepend-inner-icon="fas fa-list"
      variant="outlined"
    >
      <template #selection="{ item, index }">
        <template v-if="index === 0">
          <span v-if="params.subTasks.length === 1">{{ item.title }}</span>
          <span v-if="params.subTasks.length > 1">
            {{ $t('common.selected', { count: params.subTasks.length }) }}
          </span>
        </template>
      </template>
    </v-select>
  </div>
</template>

<script lang="ts" setup>
import { SelectResource } from '@intake24/admin/components/dialogs';
import { localeCopySubTasks } from '@intake24/common/types';
import { useI18n } from '@intake24/ui';

import { createJobParamProps, useJobParams } from './use-job-params';

const props = defineProps(createJobParamProps<'LocaleCopy'>());

const emit = defineEmits(['update:modelValue']);

const { params } = useJobParams<'LocaleCopy'>(props, { emit });

const { i18n } = useI18n();
const subTasks = localeCopySubTasks.map(value => ({
  title: i18n.t(`jobs.types.LocaleCopy.subTasks.${value}`),
  value,
}));
</script>

<style scoped></style>
